// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowDropdownSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4">
            <path
                fill="currentColor"
                d="M6.80782623,1.13750013 L4.02171651,3.80416679 C3.86608004,3.93541654 3.6863311,4 3.50658216,4 C3.32683322,4 3.14752246,3.93489583 3.01051864,3.8046875 L0.224408921,1.13802083 C0.00420338441,0.947916667 -0.0558679051,0.660416603 0.0527266839,0.412500064 C0.161321273,0.164583524 0.417310025,0 0.700743692,0 L6.29269155,0 C6.5763443,0 6.83237687,0.162104289 6.94110291,0.411458333 C7.04982895,0.660812378 7.00949511,0.947916667 6.80782589,1.13750013 L6.80782623,1.13750013 Z"
            />
        </svg>
    );
};

export default React.memo(IconArrowDropdownSmall);
